import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  List,
  ListItem,
  Text,
  useDisclosure,
  Spinner,
  Input,
  InputGroup,
  InputLeftElement,
  Tooltip,
} from '@chakra-ui/react';
import { MagnifyingGlass, Globe } from '@phosphor-icons/react';
import { searchSites } from '../../utils/elasticsearchApi';
import { useCreateSite } from '../../context/CreateSiteContext';

const ExistingSitesPopup = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { setSiteData } = useCreateSite();
  const [sites, setSites] = useState([]);
  const [filteredSites, setFilteredSites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      searchSites({ query: '', size: 10000 }) // Fetch all sites
        .then(result => {
          console.log('Search result:', result);
          if (result.success && result.data) {
            const siteNames = result.data.map(site => site.name).filter(name => name).sort();
            setSites(siteNames);
            setFilteredSites(siteNames);
          } else {
            console.error('Failed to load sites:', result.error);
          }
          setLoading(false);
        })
        .catch(error => {
          console.error('Error loading sites:', error);
          setLoading(false);
        });
    }
  }, [isOpen]);

  useEffect(() => {
    if (searchTerm === '') {
      setFilteredSites(sites);
    } else {
      setFilteredSites(
        sites.filter(site =>
          site.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm, sites]);

  const handleSiteClick = (siteName) => {
    setSiteData(prevData => ({ ...prevData, name: siteName }));
    onClose();
  };

  return (
    <>
      <Tooltip label="View and search all existing sites" aria-label="A tooltip for viewing existing sites" placement="top">
        <Button onClick={onOpen} size="sm" variant="ghost" ml={1} leftIcon={<Globe size={18} />} colorScheme="gray">
          View Existing
        </Button>
      </Tooltip>

      <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Existing Sites</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <InputGroup mb={4}>
              <InputLeftElement pointerEvents="none">
                <MagnifyingGlass />
              </InputLeftElement>
              <Input
                placeholder="Search existing sites..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
            {loading ? (
              <Box display="flex" justifyContent="center" p={10}>
                <Spinner />
              </Box>
            ) : (
              <List spacing={2}>
                {filteredSites.map((siteName, index) => (
                  <ListItem 
                    key={index} 
                    p={2} 
                    _hover={{ bg: 'gray.100', cursor: 'pointer' }} 
                    borderRadius="md"
                    onClick={() => handleSiteClick(siteName)}
                  >
                    <Text>{siteName}</Text>
                  </ListItem>
                ))}
              </List>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ExistingSitesPopup;
